import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = err => {
	const errorMsg = err.response?.data?.message || err.response?.data?.error;
	const statusCode = err.response?.status;
	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			const translated = i18n.t(`backendErrors.${errorMsg}`);
			toast.error(translated, {
				toastId: errorMsg,
			});
		} else if (typeof errorMsg === "string" && errorMsg.startsWith("ERR_")) {
			// Erro do backend com chave ERR_* (ex: restaurar histórico, permissões, etc).
			// Mesmo que ainda não haja tradução para esta chave, mostramos APENAS o
			// texto original em português ou human-readble do backend, sem prefixar
			// com "(HTTP 400) [ERR_XXX]" — o usuário não precisa ver código técnico.
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		} else {
			const prefixed = statusCode ? `(HTTP ${statusCode}) ${errorMsg}` : errorMsg;
			toast.error(prefixed, {
				toastId: errorMsg,
			});
		}
	} else if (!err?.response) {
		// Não chegou resposta nenhuma do servidor. O caso comum é o navegador
		// ter desistido antes (timeout) — acontece com arquivo grande em
		// conexão de subida lenta: o upload continua, mas a tela não tem o que
		// mostrar. Antes caía no "An error occurred!" genérico e não havia como
		// saber se era rede, tamanho ou servidor.
		const expirou =
			err?.code === "ECONNABORTED" || err?.code === "ETIMEDOUT";
		toast.error(
			expirou
				? "O servidor demorou demais para responder. Se estava enviando um arquivo, confira a conexão e tente de novo."
				: "Não consegui falar com o servidor. Verifique a conexão e tente novamente."
		);
	} else if (statusCode === 413) {
		toast.error("O arquivo enviado é maior do que o servidor aceita.");
	} else if (statusCode === 502 || statusCode === 503 || statusCode === 504) {
		toast.error("O servidor não respondeu a tempo. Tente novamente em instantes.");
	} else {
		toast.error("A operação não foi concluída. Tente novamente.");
	}
};

export default toastError;
